import {
    Avatar,
    Button,
    Card,
    Checkbox,
    Col,
    ColProps,
    Divider,
    Form,
    List,
    Radio,
    Row,
    Select,
    Skeleton,
    Space,
    Tag,
} from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { CategoryIcon } from '../mainCategory/Icon';
import { Context } from '../MunicipalNoticeBoard';
import { useHistory, useLocation } from 'react-router-dom';
import { IFolderData, IItem, ILocation, ISkleraItem } from '../utils/interface';
import { ArrowLeftOutlined, ArrowRightOutlined, DownloadOutlined, EyeFilled, FileFilled } from '@ant-design/icons';
import { downloadFile, sortForAlphabetic, sortForNewest, sortForOldest } from '../utils/helpers';
import Viewer from '../pdfViewer/Viewer';
import { skleraSDK } from '@sklera/sdk';
import { CatAvatar } from './CatAvatar';
import { HumanReadableDate } from '../utils/HumanReadableDate';
import { device } from '../breakpoints';

const ButtonDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const ContentDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const PVDocumentList = () => {
    const ctx = useContext(Context);
    const { allFolders, icons, allDocuments } = ctx;
    const [selectedItem, setSelectedItem] = useState<ISkleraItem | null>(null);
    const [subCatFilter, setSubCatFilter] = useState<string[]>([]);
    const [sort, setSort] = useState<string>('newest');

    const location = useLocation<{ categoryId: string }>();
    const history = useHistory();
    const { categoryId } = location.state;

    const folder = allFolders?.get(categoryId) as IFolderData;
    console.log(folder, sort);

    function closePdfViewer() {
        setSelectedItem(null);
    }

    if (!folder) {
        <span>Fehler &ndash; Kategorie existiert nicht</span>;
    }

    const documents = (
        allDocuments?.filter((document) => {
            if (document.categoryId === categoryId) {
                if (subCatFilter.length) {
                    if (document.subCategoryId) {
                        return subCatFilter.includes(document.subCategoryId);
                    }
                } else {
                    return true;
                }
            }
        }) || []
    ).sort((a, b) => {
        if (sort === 'newest') {
            return sortForNewest(a, b);
        }
        if (sort === 'oldest') {
            return sortForOldest(a, b);
        }

        if (sort === 'alphabetic') {
            return sortForAlphabetic(a, b);
        }

        return 0;
    });

    console.log(documents);

    const options = folder.children.filter((cf) => cf.countDocuments).map((cf) => ({ label: cf.name, value: cf._id }));

    return (
        <>
            <Row gutter={10}>
                <Col xs={{ span: 24 }} lg={{ span: 10 }}>
                    <Row gutter={10}>
                        <Col xs={{ flex: '150px' }} lg={{ span: 24 }}>
                            <nav>
                                <Button
                                    onClick={() => history.push({ pathname: '/', search: location.search })}
                                    // icon={<ArrowLeftOutlined />}
                                    style={{ marginBottom: 20 }}
                                    title="Zurück zur Kategorieübersicht">
                                    Zurück
                                </Button>
                            </nav>
                        </Col>
                        <Col xs={{ flex: 'auto' }} lg={{ span: 24 }}>
                            <div>
                                <Col xs={{ span: 0 }} lg={{ span: 24 }}>
                                    <span className="category-title-meta">Kategorie:</span>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                    <h2 className="category-title" title={'Aktuelle Kategorie: ' + folder.name}>
                                        <CatAvatar folder={folder}></CatAvatar> {folder.name}
                                    </h2>
                                </Col>
                            </div>
                            <Col xs={{ span: 0 }} lg={{ span: 24 }}>
                                {options.length ? (
                                    <>
                                        <Form.Item
                                            label="Nach Unterkategorie filtern:"
                                            labelCol={{ span: 24 }}
                                            wrapperCol={{ span: 24 }}>
                                            <Checkbox.Group
                                                value={subCatFilter}
                                                onChange={(v) => setSubCatFilter(v as string[])}
                                                style={{ display: 'block' }}>
                                                <Row>
                                                    {options.map((option) => (
                                                        <Col span={24} key={option.value}>
                                                            {' '}
                                                            <Checkbox value={option.value} style={{ marginBottom: 5 }}>
                                                                <Tag color={'red'} title={'Kategorie: ' + option.label}>
                                                                    {option.label}
                                                                </Tag>
                                                            </Checkbox>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Checkbox.Group>
                                            <Button onClick={() => setSubCatFilter([])}>Filter aufheben</Button>
                                        </Form.Item>
                                    </>
                                ) : (
                                    ''
                                )}
                            </Col>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 14 }} style={{ overflow: 'scroll' }}>
                    <div style={{ display: 'flex', justifyContent: 'end', marginRight: 10 }}>
                        <Form.Item label="Sortierung">
                            <Select
                                style={{ width: 200 }}
                                placeholder="Wähle Sortierung der Dokumente"
                                value={sort}
                                onChange={setSort}
                                options={[
                                    { label: 'Neueste zuerst', value: 'newest' },
                                    { label: 'Älteste zuerst', value: 'oldest' },
                                    { label: 'Alphabetisch', value: 'alphabetic' },
                                ]}></Select>
                        </Form.Item>
                    </div>
                    <Divider style={{ margin: 0 }}></Divider>
                    <List
                        className="public-view__document-list"
                        itemLayout="horizontal"
                        dataSource={documents}
                        renderItem={(item) => (
                            <DocumentListItem
                                item={item}
                                setSelectedItem={setSelectedItem}
                                category={options.find((o) => item.subCategoryId === o.value)?.label}
                                key={item._id}
                            />
                        )}></List>
                </Col>
                <Col span={24}>
                    <Row>
                        {folder.countDocuments && folder.countDocuments > 0
                            ? 'Anzahl Dokumente: ' + folder.countDocuments
                            : 'Keine Dokumente in dieser Kategorie vorhanden.'}
                    </Row>
                </Col>
            </Row>

            {selectedItem ? (
                <div className="pdf-viewer-modal">
                    <Viewer selectedItem={selectedItem} closePdfViewer={closePdfViewer} />
                </div>
            ) : null}
        </>
    );
};

const DocumentListItem: React.FC<{
    item: IItem;
    category?: string;
    setSelectedItem: React.Dispatch<React.SetStateAction<ISkleraItem | null>>;
}> = ({ item, setSelectedItem, category }) => {
    const skleraItem = React.useRef<ISkleraItem>();

    const getSkleraItem = async (): Promise<ISkleraItem> => {
        if (skleraItem.current) {
            return skleraItem.current;
        } else {
            const { _id, name, data } = item;
            const i = {
                ...(await skleraSDK.getItemData(item._id)),
                name: name,
                description: data?.description || null,
                _id,
            };
            skleraItem.current = i;
            return i;
        }
    };

    const downloadItem = async () => {
        const s = await getSkleraItem();
        downloadFile(s);
    };
    const getItemData = async () => {
        const s = await getSkleraItem();
        setSelectedItem(s);
    };

    let catDesc = <></>;
    if (category) {
        catDesc = (
            <>
                <br />
                <Tag color={'red'} title={'Unterkategorie des Dokuments: ' + category}>
                    {category}
                </Tag>
            </>
        );
    }

    return (
        <List.Item style={{ padding: 10 }}>
            <List.Item.Meta
                avatar={<Avatar icon={<FileFilled />} alt="Datei-Icon des Dokuments" />}
                title={
                    <a
                        href={undefined}
                        onClick={() => (`@media${device.mobileL}` ? getItemData() : null)}
                        className="getPreview"
                        aria-label={'Dokument Vorschau: ' + item.name}
                        title={'Dokument Vorschau: ' + item.name}>
                        {item.name}
                    </a>
                }
                description={
                    <span>
                        <HumanReadableDate validFrom={item.validFrom} validTo={item.validTo}></HumanReadableDate>
                        {catDesc}
                    </span>
                }
            />
            <Space.Compact direction="vertical">
                {/* <Button
                    onClick={() => getItemData()}
                    // icon={<EyeFilled></EyeFilled>}
                    title={'Vorschau für Dokument ' + item.name + ' aufrufen'}>
                    Vorschau
                </Button> */}
                <Button
                    type="primary"
                    onClick={() => downloadItem()}
                    // icon={<DownloadOutlined></DownloadOutlined>}
                    title={item.name + ' downloaden'}>
                    Download
                </Button>
            </Space.Compact>
        </List.Item>
    );

    return (
        <List.Item style={{ padding: 10 }}>
            <List.Item.Meta
                avatar={<Avatar icon={<FileFilled />} alt="Datei-Icon des Dokuments" />}
                title={
                    <a
                        href={undefined}
                        onClick={() => (`@media${device.mobileL}` ? getItemData() : null)}
                        className="getPreview"
                        aria-label={'Dokument Vorschau: ' + item.name}
                        title={'Dokument Vorschau: ' + item.name}>
                        {item.name}
                    </a>
                }
                description={
                    <span>
                        <HumanReadableDate validFrom={item.validFrom} validTo={item.validTo}></HumanReadableDate>
                        {catDesc}
                    </span>
                }
            />
            <Space.Compact direction="vertical">
                {/* <Button
                    onClick={() => getItemData()}
                    // icon={<EyeFilled></EyeFilled>}
                    title={'Vorschau für Dokument ' + item.name + ' aufrufen'}>
                    Vorschau
                </Button> */}
                <Button
                    type="primary"
                    onClick={() => downloadItem()}
                    // icon={<DownloadOutlined></DownloadOutlined>}
                    title={item.name + ' downloaden'}>
                    Download
                </Button>
            </Space.Compact>
        </List.Item>
    );
};
